export default __webpack_public_path__ + "static/media/default.c9e26ad876cc28c3d9a5075aee238393.png";